import useTranslation from 'next-translate/useTranslation'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import {
  checkoutCapacityConflictHasTimesSelector,
  checkoutCapacityConflictRequestedTimeSelector,
  checkoutCapacityConflictSingleSelector,
} from '../../store/checkoutSelectors'
import getCapacityConflictRequestedTimeLabel from '../../utils/getCapacityConflictRequestedTimeLabel'
import useCapacityConflictActions from '../../hooks/useCapacityConflictActions'

import CapacityConflictFooter from './CapacityConflictFooter'
import CapacityConflictStepDescription from './CapacityConflictStepDescription'

export default function CapacityConflictDeleteOrderStep() {
  const { t } = useTranslation('common')

  const single = useAppSelector(checkoutCapacityConflictSingleSelector)
  const hasTimes = useAppSelector(checkoutCapacityConflictHasTimesSelector)
  const { isPending, deleteOrder, chooseAnotherDay, cancel } =
    useCapacityConflictActions()
  const requestedTime = useAppSelector(
    checkoutCapacityConflictRequestedTimeSelector,
  )

  const formattedRequestedTime = getCapacityConflictRequestedTimeLabel(
    requestedTime,
    t,
  )

  function handleClose() {
    cancel()
  }

  function handleDeleteOrder() {
    deleteOrder()
  }

  function handleChooseAnotherDay() {
    chooseAnotherDay()
  }

  return (
    <>
      <CapacityConflictStepDescription>
        {single
          ? t('checkoutCapacityConflict.deleteStepSingleMessage', {
              time: formattedRequestedTime,
            })
          : t('checkoutCapacityConflict.deleteStepMessage')}
      </CapacityConflictStepDescription>
      <CapacityConflictFooter
        secondaryLabel={
          hasTimes
            ? t('checkoutCapacityConflict.keepOrderButton')
            : t('checkoutCapacityConflict.deleteOrderButton')
        }
        onSecondaryClick={hasTimes ? handleClose : handleDeleteOrder}
        primaryLabel={
          hasTimes
            ? t('checkoutCapacityConflict.confirmDeleteButton')
            : t('checkoutCapacityConflict.chooseAnotherDayButton')
        }
        onPrimaryClick={hasTimes ? handleDeleteOrder : handleChooseAnotherDay}
        isDestructivePrimary={hasTimes}
        primaryDisabled={isPending}
      />
    </>
  )
}
